import sanitizeHtml from 'sanitize-html';
import { getLiteral } from 'utils/getLiteral';

export const FIXED_FOOTER_TOKENS = {
    senderName: '-senderName-',
    senderAddress: '-senderAddress-',
    footerHere: '-footerHere-',
    link: '-link-',
};

export const FIXED_FOOTER_IDS = {
    container: 'legal-footer',
    senderName: 'fm-topol-footer-sender-name',
    senderAddress: 'fm-topol-footer-sender-address',
    unsubscribeLink: 'fm-topol-footer-unsubscribe-link',
};

const FIXED_FOOTER_REQUIRED_TOKEN_PAIRS = [
    { token: FIXED_FOOTER_TOKENS.senderName, id: FIXED_FOOTER_IDS.senderName, tag: 'p' },
    { token: FIXED_FOOTER_TOKENS.senderAddress, id: FIXED_FOOTER_IDS.senderAddress, tag: 'p' },
    { token: FIXED_FOOTER_TOKENS.footerHere, id: FIXED_FOOTER_IDS.unsubscribeLink, tag: 'a' },
];

const FOOTER_PARAGRAPH_STYLE = 'margin:\\s*0\\s+0\\s+4px\\s+0';
const FOOTER_ADDRESS_PARAGRAPH_PATTERN = new RegExp(
    `(<p style="${FOOTER_PARAGRAPH_STYLE};">[\\s\\S]*?<\\/p>\\s*)(<p style="${FOOTER_PARAGRAPH_STYLE};">)[\\s\\S]*?(<\\/p>)(\\s*<p style="margin:\\s*0;">\\s*<a[^>]*id="${FIXED_FOOTER_IDS.unsubscribeLink}"|\\s*<p style="margin:\\s*0;">\\s*<a[^>]*color:#10b981)`,
    'i',
);
const FOOTER_UNSUBSCRIBE_LINK_PATTERN =
    /<a([^>]*href=")[^"]*("[^>]*id="fm-topol-footer-unsubscribe-link"[^>]*>)[\s\S]*?(<\/a>)|<a([^>]*href=")[^"]*("[^>]*color:#10b981[^>]*>)[\s\S]*?(<\/a>)/i;
const FIXED_FOOTER_CONTAINER_PATTERN = new RegExp(
    `<([a-z0-9:-]+)([^>]*id="${FIXED_FOOTER_IDS.container}"[^>]*)>[\\s\\S]*?<\\/\\1>`,
    'i',
);
const HTML_BODY_CLOSE_PATTERN = /<\/body\s*>/i;
const HIDDEN_STYLE_PATTERN =
    /display\s*:\s*none|visibility\s*:\s*hidden|opacity\s*:\s*0(?:[;\s]|$)/i;
const EMPTY_STRING = '';

export const FIXED_FOOTER_ISSUE_TYPES = {
    none: 'none',
    notFound: 'not_found',
    modified: 'modified',
};

export const buildFixedFooterContent = () => `
        <div id="${FIXED_FOOTER_IDS.container}">
            <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width:100%;">
                <tr>
                    <td align="center">
                        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width:100%; max-width:600px; margin:0 auto;">
                            <tr>
                                <td align="center" style="padding:12px; font-family:Arial, Helvetica, sans-serif; font-size:14px; line-height:20px; color:inherit; text-align:center; word-break:break-word; -webkit-text-size-adjust:100%;">
                                    <p id="${FIXED_FOOTER_IDS.senderName}" style="margin:0 0 4px 0;">
                                    ${FIXED_FOOTER_TOKENS.senderName}
                                    </p>
                                    <p id="${FIXED_FOOTER_IDS.senderAddress}" style="margin:0 0 4px 0;">
                                    ${FIXED_FOOTER_TOKENS.senderAddress}
                                    </p>
                                    <p style="margin:0;">
                                        <a id="${FIXED_FOOTER_IDS.unsubscribeLink}" href="${FIXED_FOOTER_TOKENS.link}" style="font-weight:500;">
                                            ${FIXED_FOOTER_TOKENS.footerHere}
                                        </a>
                                    </p>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>
        </div>
`;

export const buildHtmlEditorDefaultWithFixedFooter = () => `
<!DOCTYPE html>
<html>
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <style>
            body {
                margin:0;
                padding:0;
            }
        </style>
    </head>
    <body style="margin:0;padding:0;background-color:#f4f6f8;">
        

        <!-- MAIN CONTENT SECTION -->

        <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="margin-bottom:40px;">
            <tr>
            <td align="center" style="padding:40px 16px 0 16px;">
                <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="width:100%; max-width:600px;">
                <tr>
                    <td style="padding:32px 24px; box-sizing:border-box; background-color:#ffffff; border-radius:12px; border: 1px solid #e2e8f0; text-align: center; color:#1f2933;">

                    <h1 style="margin: 0; font-size:24px; line-height:32px; font-weight:bold; color:#111827; word-break:break-word;">
                        ${getLiteral('label_marketing_campaigns_design_start_your_design_here')}
                    </h1>

                    </td>
                </tr>
                </table>

            </td>
            </tr>
        </table>


        ${buildMandatoryFooterComment()}
        ${buildFixedFooterContent()}
    </body>
</html>`;

const buildMandatoryFooterComment = () => `
        <!-- MANDATORY FOOTER -->
        <!-- ${getLiteral('label_marketing_campaigns_design_footer_html_important_comment')} -->`;

const isPresent = (value) => value != null && value !== EMPTY_STRING;

const escapeHtml = (value) => {
    if (!isPresent(value)) {
        return EMPTY_STRING;
    }

    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
};

const looksLikeHtml = (value) => /<[a-z][\s\S]*?>/i.test(String(value));

const normalizeHtmlForCompare = (html) =>
    String(html).replace(/\s+/g, ' ').replace(/>\s+</g, '><').trim();

const replaceAllSafe = (content, from, to) => {
    if (!from || !content?.includes(from)) {
        return content;
    }
    return content.replaceAll(from, to);
};

const formatFooterAddressForPreview = (address) => {
    if (!isPresent(address)) {
        return EMPTY_STRING;
    }

    const raw = String(address).trim();
    if (looksLikeHtml(raw)) {
        return sanitizeHtml(raw);
    }

    return escapeHtml(raw).replace(/\n/g, '<br>');
};

const replaceFooterBlockWithDefault = (html) => {
    if (!html) {
        return html;
    }

    const defaultFooter = buildFixedFooterContent();
    const defaultFooterWithComment = `${buildMandatoryFooterComment()}\n        ${defaultFooter}`;

    if (FIXED_FOOTER_CONTAINER_PATTERN.test(html)) {
        return html.replace(FIXED_FOOTER_CONTAINER_PATTERN, defaultFooter);
    }

    if (HTML_BODY_CLOSE_PATTERN.test(html)) {
        return html.replace(HTML_BODY_CLOSE_PATTERN, `${defaultFooterWithComment}\n</body>`);
    }

    return `${html}\n${defaultFooterWithComment}`;
};

const hasVisibleTokenInExpectedElement = ({ html, tag, id, token }) => {
    if (!html?.includes(token)) {
        return false;
    }

    const pattern = new RegExp(`<${tag}([^>]*)id="${id}"([^>]*)>([\\s\\S]*?)<\\/${tag}>`, 'i');
    const match = html.match(pattern);

    if (!match) {
        return false;
    }

    const attrs = `${match[1] || ''} ${match[2] || ''}`;
    const content = match[3] || '';

    if (!content.includes(token)) {
        return false;
    }

    if (/\shidden(\s|>|=)/i.test(attrs)) {
        return false;
    }

    if (HIDDEN_STYLE_PATTERN.test(attrs)) {
        return false;
    }

    return true;
};

const hasLinkTokenInUnsubscribeHref = (html) => {
    const pattern = new RegExp(
        `<a([^>]*)id="${FIXED_FOOTER_IDS.unsubscribeLink}"([^>]*)href="([^"]*)"([^>]*)>`,
        'i',
    );
    const match = html.match(pattern);

    if (!match) {
        return false;
    }

    const attrs = `${match[1] || ''} ${match[2] || ''} ${match[4] || ''}`;
    const hrefValue = match[3] || '';

    if (/\shidden(\s|>|=)/i.test(attrs)) {
        return false;
    }

    if (HIDDEN_STYLE_PATTERN.test(attrs)) {
        return false;
    }

    return hrefValue.includes(FIXED_FOOTER_TOKENS.link);
};

const buildPreviewReplacements = (preview) => {
    if (!preview) {
        return [];
    }

    const replacements = [];
    if (isPresent(preview.senderName)) {
        replacements.push([FIXED_FOOTER_TOKENS.senderName, escapeHtml(preview.senderName)]);
    }
    if (isPresent(preview.senderAddress)) {
        replacements.push([
            FIXED_FOOTER_TOKENS.senderAddress,
            formatFooterAddressForPreview(preview.senderAddress),
        ]);
    }
    if (isPresent(preview.footerHere)) {
        replacements.push([FIXED_FOOTER_TOKENS.footerHere, escapeHtml(preview.footerHere)]);
    }
    if (isPresent(preview.linkHref)) {
        replacements.push([FIXED_FOOTER_TOKENS.link, escapeHtml(preview.linkHref)]);
    }
    return replacements;
};

const applyReplacements = (content, replacements) =>
    replacements.reduce((acc, [from, to]) => replaceAllSafe(acc, from, to), content);

export const applyFixedFooterPreviewToHtml = (html, preview) => {
    if (!html || !preview) {
        return html;
    }

    return applyReplacements(html, buildPreviewReplacements(preview));
};

const replaceFooterAddressParagraphWithToken = (html) =>
    html.replace(
        FOOTER_ADDRESS_PARAGRAPH_PATTERN,
        `$1$2\n              ${FIXED_FOOTER_TOKENS.senderAddress}\n            $3$4`,
    );

const replaceFooterUnsubscribeLinkWithTokens = (html) =>
    html.replace(
        FOOTER_UNSUBSCRIBE_LINK_PATTERN,
        `<a$1${FIXED_FOOTER_TOKENS.link}$2${FIXED_FOOTER_TOKENS.footerHere}$3`,
    );

const replaceElementInnerHtmlById = (html, { tag, id, replacement }) => {
    const pattern = new RegExp(`(<${tag}[^>]*id="${id}"[^>]*>)[\\s\\S]*?(<\\/${tag}>)`, 'i');
    return html.replace(pattern, `$1${replacement}$2`);
};

const replaceLinkHrefById = (html, { id, replacement }) => {
    const pattern = new RegExp(`(<a[^>]*id="${id}"[^>]*href=")[^"]*(")`, 'i');
    return html.replace(pattern, `$1${replacement}$2`);
};

const enforceFooterTokensById = (html) => {
    let next = html;

    if (!next.includes(FIXED_FOOTER_TOKENS.senderName)) {
        next = replaceElementInnerHtmlById(next, {
            tag: 'p',
            id: FIXED_FOOTER_IDS.senderName,
            replacement: FIXED_FOOTER_TOKENS.senderName,
        });
    }
    if (!next.includes(FIXED_FOOTER_TOKENS.senderAddress)) {
        next = replaceElementInnerHtmlById(next, {
            tag: 'p',
            id: FIXED_FOOTER_IDS.senderAddress,
            replacement: FIXED_FOOTER_TOKENS.senderAddress,
        });
    }
    if (!next.includes(FIXED_FOOTER_TOKENS.footerHere)) {
        next = replaceElementInnerHtmlById(next, {
            tag: 'a',
            id: FIXED_FOOTER_IDS.unsubscribeLink,
            replacement: FIXED_FOOTER_TOKENS.footerHere,
        });
    }
    if (!next.includes(FIXED_FOOTER_TOKENS.link)) {
        next = replaceLinkHrefById(next, {
            id: FIXED_FOOTER_IDS.unsubscribeLink,
            replacement: FIXED_FOOTER_TOKENS.link,
        });
    }

    return next;
};

const restoreAddressToken = (html, preview) => {
    if (!isPresent(preview?.senderAddress)) {
        return html;
    }

    const addressRaw = String(preview.senderAddress).trim();
    const addressPreview = formatFooterAddressForPreview(preview.senderAddress);
    let next = html;

    if (addressPreview && next.includes(addressPreview)) {
        return next.replaceAll(addressPreview, FIXED_FOOTER_TOKENS.senderAddress);
    }

    if (!looksLikeHtml(addressRaw)) {
        const escaped = escapeHtml(addressRaw).replace(/\n/g, '<br>');
        if (escaped && next.includes(escaped)) {
            return next.replaceAll(escaped, FIXED_FOOTER_TOKENS.senderAddress);
        }
        const lines = addressRaw.split('\n').map((line) => escapeHtml(line.trim()));
        lines.forEach((line) => {
            if (line && next.includes(line)) {
                next = next.replaceAll(line, FIXED_FOOTER_TOKENS.senderAddress);
            }
        });
        return next;
    }

    const normalizedAddress = normalizeHtmlForCompare(addressPreview);
    const normalizedDoc = normalizeHtmlForCompare(next);
    if (!normalizedAddress || !normalizedDoc.includes(normalizedAddress)) {
        return next;
    }

    const start = normalizedDoc.indexOf(normalizedAddress);
    const end = start + normalizedAddress.length;
    const ratio = next.length / Math.max(normalizedDoc.length, 1);
    const approxStart = Math.floor(start * ratio);
    const approxEnd = Math.ceil(end * ratio);
    return `${next.slice(0, approxStart)}${FIXED_FOOTER_TOKENS.senderAddress}${next.slice(approxEnd)}`;
};

export const restoreFixedFooterTokensInHtml = (html, preview) => {
    if (!html) {
        return html;
    }

    let next = html;
    if (preview?.linkHref) {
        next = replaceLinkHrefById(next, {
            id: FIXED_FOOTER_IDS.unsubscribeLink,
            replacement: FIXED_FOOTER_TOKENS.link,
        });
    }
    if (preview?.footerHere) {
        next = replaceAllSafe(next, escapeHtml(preview.footerHere), FIXED_FOOTER_TOKENS.footerHere);
    }
    if (preview?.senderName) {
        next = replaceAllSafe(next, escapeHtml(preview.senderName), FIXED_FOOTER_TOKENS.senderName);
    }
    next = restoreAddressToken(next, preview);
    next = enforceFooterTokensById(next);

    if (!next.includes(FIXED_FOOTER_TOKENS.senderAddress)) {
        next = replaceFooterAddressParagraphWithToken(next);
    }
    if (
        !next.includes(FIXED_FOOTER_TOKENS.link) ||
        !next.includes(FIXED_FOOTER_TOKENS.footerHere)
    ) {
        next = replaceFooterUnsubscribeLinkWithTokens(next);
    }

    return next;
};

export const ensureFixedFooterVisibleTokensOrDefault = (html) => {
    if (!html) {
        return replaceFooterBlockWithDefault(buildHtmlEditorDefaultWithFixedFooter());
    }

    if (getFixedFooterIssueType(html) === FIXED_FOOTER_ISSUE_TYPES.none) {
        return html;
    }

    return replaceFooterBlockWithDefault(html);
};

export const getFixedFooterIssueType = (html) => {
    if (!html || !FIXED_FOOTER_CONTAINER_PATTERN.test(html)) {
        return FIXED_FOOTER_ISSUE_TYPES.notFound;
    }

    const hasAllVisibleTokens = FIXED_FOOTER_REQUIRED_TOKEN_PAIRS.every((requiredToken) =>
        hasVisibleTokenInExpectedElement({
            html,
            tag: requiredToken.tag,
            id: requiredToken.id,
            token: requiredToken.token,
        }),
    );

    const hasVisibleLinkToken = hasLinkTokenInUnsubscribeHref(html);

    if (hasAllVisibleTokens && hasVisibleLinkToken) {
        return FIXED_FOOTER_ISSUE_TYPES.none;
    }

    return FIXED_FOOTER_ISSUE_TYPES.modified;
};

export const resolveHtmlEditorContentForLoad = (html) => {
    if ((html || '').trim()) {
        return html;
    }

    return buildHtmlEditorDefaultWithFixedFooter();
};
